
import * as React from 'react';

import SaleContent from '../../components/Sale'
import Layout from '../../components/Layout'


const Sale = (props) => (
  <Layout>
    <SaleContent />
  </Layout>
);

export default Sale;
